import { render, staticRenderFns } from "./shortOrderInfo.vue?vue&type=template&id=625871b4&scoped=true&"
import script from "./shortOrderInfo.vue?vue&type=script&lang=js&"
export * from "./shortOrderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625871b4",
  null
  
)

export default component.exports